

























































































import { Component, Vue } from 'vue-property-decorator'
import { Result } from '../../modules/class/RegisterResponseInfo'
import ErrorFormResponse from '../../modules/class/ErrorFormResponse'
import PathUtil from '../../modules/util/PathUtil'
import JsonUtil from '../../modules/util/JsonUtil'
import axios from 'axios'
import { membershipState } from '../../store/modules/MembershipState'
import UidCookie from '../../modules/util/UidSetCookie'
import { getUserInfo, SapLoginInfo } from '../../modules/util/SapUtil'

@Component
export default class ReLogin extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data
  private password = ''
  private email = ''
  private uid = ''
  private clickUpdate = false
  private result: Result = 'error'
  private resultError: ErrorFormResponse = {}
  private haserror = false
  private errorText = ''
  private isSuccessful = false
  private isReLoginModalVisible = true
  private event = { target: { value: 0 } }
  private checkBoxNode: null | HTMLInputElement = null
  private uidcookie = new UidCookie()
  // --------------------------------------------------------------------------------------------------------------------
  // Props

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private mounted() {
    // confirm押下時にUIDとメールアドレスを送りたいので先に情報取得
    if (membershipState.sapLoginInfo.UID || membershipState.userInfo.email) {
      getUserInfo()
    }

    // Update my accountチェックボックスにイベント追加
    this.setEventForHTMLElements()
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private clearelemnt() {
    this.password = ''
    this.clickUpdate = false
    this.resultError = {}
    this.haserror = false
    this.errorText = ''
  }

  private close() {
    this.clearelemnt()
    // 再認証未成功時はチェックを外す
    if (this.checkBoxNode !== null && !this.isSuccessful) {
      this.checkBoxNode.checked = false
    }
  }

  /**
   * confirmクリック
   */
  private async checkAuthCode() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginReloginResponse
    })
  }

  /**
   * サインアウトコールバック
   */
  private async verifyLoginReloginResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    this.errorText = ''
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)
      const form = JSON.stringify({
        password: this.password,
        uid: membershipState.sapLoginInfo.UID,
        email: membershipState.userInfo.email
      })
      const res = await axios.post(
        PathUtil.makePath('/member/api/relogin'),
        form
      )
      if (res === undefined || res.status !== 200) {
        // システムエラー
        this.isSuccessful = false
        this.haserror = true
        this.errorText = 'systemerror'
        return
      }
      this.result = res.data.result
      if (this.result === 'success') {
        // formのhiddenにパスワードをセットする
        const passwordNode = document.getElementById(
          'edit-relogin-password'
        ) as HTMLInputElement
        passwordNode.value = this.password ?? ''
        // success entry finish
        this.isSuccessful = true
      } else {
        this.isSuccessful = false
        this.haserror = true
        // show error message
        this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
          ErrorFormResponse,
          res.data.errordata || {}
        )
        if (this.resultError.common === undefined) {
          this.errorText = 'resultError undefined'
        }
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
      // エラー表示
      this.isSuccessful = false
      this.haserror = true
      this.errorText = 'verifyLogin errorCode:' + response.errorCode
    }
  }

  /**
   * 問い合わせフォームから会員情報更新時のイベントを仕込む
   */
  private setEventForHTMLElements() {
    // Update my accountを取得
    this.checkBoxNode = document.getElementById(
      'edit-update-my-account'
    ) as HTMLInputElement

    let buttonNode = document.getElementById(
      'edit-actions-preview-next'
    ) as HTMLInputElement
    if (!buttonNode) {
      // webformのボタンが未カスタマイズの場合、標準を呼び出す
      buttonNode = document.getElementById(
        'edit-preview-next'
      ) as HTMLInputElement
    }

    const passwordNode = document.getElementById(
      'edit-relogin-password'
    ) as HTMLInputElement

    // 送信内容確認ボタンのクリックイベントに、Update my accountを確認し
    // チェックがついている場合は、パスワード確認を表示する処理仕込む
    buttonNode.addEventListener(
      'click',
      (e) => {
        if (
          this.checkBoxNode !== null &&
          this.checkBoxNode.checked &&
          passwordNode.value === ''
        ) {
          this.isSuccessful = false
          this.clickUpdate = true
          e.preventDefault()
        } else {
          this.clickUpdate = false
        }
      },
      false
    )
  }
}
